export function debounce<T extends Function>(callback: T, delay = 100) {
  let timer = 0;
  let callable = (...args: any) => {
    clearTimeout(timer);
    timer = window.setTimeout(() => callback(...args), delay);
  };
  return callable as any as T;
}
